import { useEffect, useState } from 'react';

import { Checkbox, Grid } from 'coreOld/elements';

import { CheckboxWrapper } from './checkboxGroupStyle';

interface IProps {
  onChange;
  name: string;
  filter?: Record<string, any>;
  values?: string[];
  checkboxes;
  isMulti?: boolean;
}

const CheckboxGroupView = ({ onChange, checkboxes, values, isMulti = true }: IProps) => {
  const [checkedValues, setCheckedValues] = useState([]);

  useEffect(() => {
    if (!values) {
      setCheckedValues([]);
    }

    if (values && !isMulti) {
      setCheckedValues([Number(values)]);
    }
  }, [values]);

  const handleMultiCheck = (event) => {
    let updatedList = [...checkedValues];

    if (event.target?.checked) {
      updatedList = [...checkedValues, event.target.value];
    } else {
      updatedList.splice(checkedValues.indexOf(event.target.value), 1);
    }
    setCheckedValues(updatedList);

    onChange(updatedList);
  };

  const handleCheck = (event) => {
    const updatedChecked = event.target?.checked ? event.target.value : null;

    setCheckedValues([updatedChecked]);
    onChange(updatedChecked);
  };

  return (
    <CheckboxWrapper>
      {checkboxes.map((obj, index) => (
        <Grid key={obj.value} item xs={12} md={obj?.md || 4}>
          <Checkbox
            id={`checkbox-${index}-${obj.value}`}
            label={obj?.label}
            value={obj?.value || (!isMulti && values)}
            checked={checkedValues.includes(obj.value)}
            onChange={(event) => (isMulti ? handleMultiCheck(event) : handleCheck(event))}
            style={obj?.style}
          />
        </Grid>
      ))}
    </CheckboxWrapper>
  );
};

export default CheckboxGroupView;
